import { createContext, useContext } from "react";
import { products as staticProducts } from "@/data/products";
import { useSession } from "@/context/SessionContext";

const ProductsContext = createContext(null);

export function ProductsProvider({ children }) {
  const { products: bootstrapProducts, ready } = useSession();
  const products = ready && Array.isArray(bootstrapProducts) ? bootstrapProducts : staticProducts;

  const getProduct = (slug) => products.find((p) => p.slug === slug);

  return <ProductsContext.Provider value={{ products, getProduct }}>{children}</ProductsContext.Provider>;
}

export const useProducts = () => useContext(ProductsContext);
